import { useEffect, useState } from "react";
import { modeForViewport, type LayoutMode } from "./layoutMode.js";

function currentMode(): LayoutMode {
  return modeForViewport(window.innerWidth, window.innerHeight);
}

export function useViewportLayoutMode(): LayoutMode {
  const [mode, setMode] = useState(currentMode);

  useEffect(() => {
    const update = () => setMode(currentMode());
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return mode;
}
